
































import mixins from 'vue-typed-mixins';
import SurveyQuestionForm from '@/components/survey/management/questions/SurveyQuestionForm.vue';
import questionsframework, { QuestionKey } from '@/components/survey/questions';
import { Question } from '@/utils/SurveyUtils';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  components: {
    SurveyQuestionForm,
    ...questionsframework.options, // register the question options components
  },

  props: {
    questions: {
      type: Array as () => Question[],
    },
  },

  computed: {
    hasOptions(): boolean {
      return (
        !!this.question?.questiontype &&
        !!this.question?.options &&
        !Array.isArray(this.question.options) &&
        Object.keys(questionsframework.options).includes(
          this.question.questiontype.key
        )
      );
    },
  },

  data(): {
    question?: Question;
  } {
    return {
      question: undefined,
    };
  },

  methods: {
    open(question: Question) {
      const copy: Partial<Question> = {
        ...cloneDeep(question),
        questionkey: question.questionkey || '',
        questionnumber: question.questionnumber || '',
        questiontype: question.questiontype || undefined,
        condition: question.condition || undefined,
        shorttext: question.shorttext || this.$languageobj(),
        longtext: question.longtext || this.$languageobj(),
        helptext: question.helptext || this.$languageobj(),
        validation: {
          mandatory: question.validation?.mandatory || 'none',
        },
      };
      this.question = copy as Question;
      (this.$refs.modal as any).open();
    },

    async submit() {
      try {
        (this.$refs.alert as any)?.hide('submit');
        await (this.$listeners as any).submit(this.question);
        this.question = undefined;
        (this.$refs.modal as any).resolve();
      } catch (error) {
        (this.$refs.alert as any)?.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    cancel() {
      this.question = undefined;
      (this.$refs.modal as any).resolve();
    },
  },
});
